import { render, staticRenderFns } from "./messageHome.vue?vue&type=template&id=4ea8ad8a&scoped=true&"
import script from "./messageHome.vue?vue&type=script&lang=js&"
export * from "./messageHome.vue?vue&type=script&lang=js&"
import style0 from "./messageHome.vue?vue&type=style&index=0&id=4ea8ad8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea8ad8a",
  null
  
)

export default component.exports